import React, { useEffect, useRef, useState } from "react";

/** Libraries */
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { Parallax } from "react-scroll-parallax";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Link as ScrollTo } from "react-scroll";

/** Components */
import { fadeIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

/** style */
import "../../../Assets/scss/MedicalCounsellingIndia/pages/home.scss";
import MetaTags from "../../../MedicalCounsellingIndia/Components/MetaTags";
import CommonContactButton from "../../../MedicalCounsellingIndia/Components/AnotherButton/CommonContactButton";
import IconWithText from "../IconWithText/IconWithText";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { locationsData } from "./MbbsAdmissionData.js";

const IconWithTextData_06 = [
  {
    icon: "line-icon-Cap-Smiley text-fastblue",
    title: "Less competitive than state counselling.",
  },
  {
    icon: "line-icon-University-2 text-fastblue",
    title: "Ideal for students with moderate NEET scores.",
  },
  {
    icon: "line-icon-Timer text-fastblue",
    title: "Time-saving and assured seat availability if criteria are met.",
  },
];

/** top university data array */

/** top college details */
const topCollegeDetails = [
  {
    name: "Symbiosis Medical College for Women",
    link: "/direct-admission/direct-admission-in-symbiosis-medical-college-for-women",
  },
  {
    name: " Dr D Y Patil Medical College",

    link: "/direct-admission/direct-admission-in-dr-d-y-patil-medical-college",
  },
  {
    name: " Mgm Medical College",

    link: "/direct-admission/direct-admission-in-mgm-medical-college",
  },
  {
    name: " Shridevi Institute Of Medical Science,",

    link: "/direct-admission/direct-admission-in-shridevi-institute-of-medical-science",
  },
  {
    name: "Ananta Institute Of Medical Science",

    link: "/direct-admission/direct-admission-in-ananta-institute-of-medical-science",
  },
  {
    name: "Pacific Institute Of Medical Science",

    link: "/direct-admission/direct-admission-in-pacific-institute-of-medical-science ",
  },
];

function MbbsAdmission() {
  const [formLoading, setFormLoading] = useState(false);
  const [locationData, setLocationData] = useState([]);

  const collegeSectionRef = useRef(null);
  const location = useLocation();

  const { locations } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  useEffect(() => {
    const paramLocationData = locationsData.find(
      (location) => location.locationName.toLowerCase() === locations
    );

    setLocationData(paramLocationData);
  }, [locations]);

  const onSubmit = (data) => {
    console.log(data);
    setFormLoading(true);
    toast.success("Your message has been sent successfully!", {
      theme: "colored",
    });

    setTimeout(() => {
      setFormLoading(false);
    }, 1000);
  };

  const handleKeyDown = (event) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    const isNumberKey = !isNaN(Number(event.key)) && event.code !== "Space";

    if (!allowedKeys.includes(event.code) && !isNumberKey) {
      event.preventDefault();
    }
  };

  /** scroll to college */

  useEffect(() => {
    if (
      location.search.includes("scrollToCollege=true") &&
      collegeSectionRef.current
    ) {
      collegeSectionRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("hi");
    }
  }, [location.search]);

  return (
    <>
      <MetaTags
        title={locationData.metaTitle}
        description={locationData.metaDescription}
        keywords={locationData.metaKeywords}
      />
      {/* banner Parallax Scrolling Start */}
      <m.div
        className="md:flex md:items-center overflow-hidden relative md:h-[465px] sm:h-[350px] xs:h-[357px]"
        {...fadeIn}
      >
        <div className="full-screen md:flex md:items-center overflow-hidden relative sm:h-[500px] w-full">
          <Parallax
            className="lg-no-parallax bg-cover absolute top-[0px] left-0 w-full h-[100vh]"
            translateY={[-40, 40]}
            style={{
              backgroundImage: `url(/assets/img/webp/mbbsAdmissions/chhattisgarh.jpg)`,
            }}
          ></Parallax>
          <Container fluid className="relative">
            <Row className="h-[100vh] items-center">
              <Col
                xl={5}
                lg={{ span: 6, offset: 1 }}
                md={8}
                sm={10}
                className="h-full flex flex-col justify-center md:pl-[35px] xs:pl-[15px]"
              >
                <h1 className="font-serif text-white z-[1] font-semibold tracking-[-2px] w-[80%] xl:w-full mb-[12%] sm:mb-[30px] xs:w-full">
                  {locationData.title}
                </h1>
                <div className="inline-block z-[1]">
                  <span className="inline-block">
                    <ScrollTo
                      href="#"
                      to="appointment"
                      offset={0}
                      delay={0}
                      spy={true}
                      smooth={true}
                      duration={800}
                    ></ScrollTo>
                  </span>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* <div className="absolute h-full w-full opacity-75 top-0 left-0 bg-gradient-to-tr from-[#f5f5f8] via-[#dfdedd] to-[#bfb6b1]"></div> */}
      </m.div>
      {/* banner Parallax Scrolling End */}
      {/* instruction section start  */}
      <section className="bg-lightgray py-[100px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[50px]">
        <Container>
          {/* How to get Admission */}
          <div className="">
            <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-normal ">
              <span className="text-[#f78c1f]">
                MBBS Admission in {locationData.locationName}:
              </span>{" "}
              {locationData.secondHeading}
            </h1>
            <div>
              <div className="!text-[#616162] mt-4  ">
                <div
                  className="mt-3"
                  dangerouslySetInnerHTML={{
                    __html: locationData?.secondPara || "",
                  }}
                ></div>
                <div className="mt-5">
                  <div
                    className="text-[26px] font-semi-bold pb-3"
                    dangerouslySetInnerHTML={{
                      __html: locationData?.thirdHeading || "",
                    }}
                  ></div>
                  <div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: locationData?.thirdPara || "",
                      }}
                    ></div>

                    <div
                      className="mt-1"
                      dangerouslySetInnerHTML={{
                        __html: locationData?.fourthPara || "",
                      }}
                    ></div>
                  </div>
                </div>

                <section className="py-[80px] lg:py-[50px] md:py-[75px] sm:py-[50px] bg-[#f7f8fc]">
                  <Container>
                    <Row className="justify-center">
                      <m.div
                        className="col-xl-6 col-lg-7 col-sm-8 mb-20 text-center w-[51%] xl:mb-[70px] lg:mb-[65px] md:mb-[60px] sm:mb-[55px] md:w-[68%] xs:w-full"
                        {...fadeIn}
                      >
                        <h5 className="w-full mb-[20px] font-semibold text-darkgray font-serif -tracking-[1px]">
                          Eligibility Criteria for
                          <div className="text-[#f78c1f]">
                            MBBS in {locationData.locationName}
                          </div>
                        </h5>
                      </m.div>
                    </Row>
                    <Row className="justify-center">
                      <Col lg={12} md={9} xs={12}>
                        <IconWithText
                          grid="row-cols-1 row-cols-lg-2 gap-y-10 justify-center"
                          theme="icon-with-text-02"
                          data={locationData.eligibilityCriteria}
                          animation={fadeIn}
                          animationDelay={0.2}
                        />
                      </Col>
                    </Row>
                  </Container>
                </section>

                <div className="mt-3"></div>

                <div className="mt-3"></div>
              </div>
            </div>
          </div>

          <div className="mt-5 ">
            <CommonContactButton />
          </div>
          {/* general eligibility */}
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {locationData.fifthHeading}
            </h2>
            <div>
              <div
                className="!text-[#616162]"
                dangerouslySetInnerHTML={{
                  __html: locationData?.fifthPara || "",
                }}
              ></div>
            </div>
            <div>
              <div className=" font-[400] mt-4">
                {locationData.firstOlHeading}
              </div>
              {locationData.firstOl && (
                <ol className="!text-[#616162] ml-10 md:ml-5 list-decimal">
                  {locationData?.firstOl.map((item, idx) => (
                    <li key={idx}>
                      <b>{item?.title}</b>: {item?.description}
                    </li>
                  )) || []}
                </ol>
              )}

              <div className=" font-[400] mt-4">
                {locationData.secondOlHeading}
              </div>

              {locationData.secondOl && (
                <ol className="!text-[#616162] ml-10 md:ml-5 list-decimal">
                  {locationData.secondOl.map((item, idx) => (
                    <li key={idx}>
                      <b>{item.title}:</b> {item.description}
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </div>

          {/* top college */}
          <div className=" mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {/* What are top private MBA Colleges in india? */}
              {locationData.sixthHeading}
            </h2>
            <div>
              <p className="!text-[#616162] !opacity-100">
                {locationData.sixthPara}
              </p>

              <div className=" font-[400] mt-4">
                {locationData.thirdOlHeading}
              </div>
              {locationData.thirdOl && (
                <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal">
                  {locationData.thirdOl.map((item, idx) => (
                    <li key={idx}>
                      <b>{item.title}:</b> {item.description}
                    </li>
                  ))}
                </ol>
              )}

              <div className=" font-[400] mt-4">
                {locationData.fourthOlHeading}
              </div>
              {locationData.fourthOl && (
                <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal">
                  {locationData.fourthOl.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ol>
              )}

              <div>
                <span className="font-[500] text-red-400 mt-5"> Note:</span>{" "}
                {locationData.fourthOlNote}
              </div>
            </div>
          </div>
        </Container>
        <section className="py-[130px] overflow-hidden lg:py-[90px] sm:py-[75px] xs:py-[50px]">
          <Container>
            <Row className="items-center justify-center">
              <Col lg={5} md={9} className="mb-[10px] md:mb-28">
                <h4 className="font-serif font-semibold text-darkgray  ">
                  {locationData.sevenHeading}
                </h4>

                <p
                  className="w-[80%] mb-[25px] lg:w-[95%] mt-2"
                  dangerouslySetInnerHTML={{
                    __html: locationData?.sevenPara || "",
                  }}
                ></p>
                <div className=" font-[400] mt-4  text-[22px]">
                  {locationData.fifthOlHeading}
                </div>
                {locationData.fifthOl && (
                  <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal mt-2">
                    {locationData.fifthOl.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ol>
                )}
                <ScrollTo
                  to="services"
                  offset={0}
                  delay={0}
                  spy={true}
                  smooth={true}
                  duration={800}
                ></ScrollTo>
              </Col>
              <Col
                lg={7}
                md={9}
                xs={12}
                className="px-[55px] md:pr-[50px] md:pl-[5px]"
              >
                <m.figure className="image-back-offset-shadow w-100">
                  <m.img
                    className="rounded-[6px] h-[536px] object-cover "
                    src="/assets/img/webp/locations/Chhattisgarh.png"
                    alt="our-services"
                    width="572.5"
                    height="436.53"
                    initial={{ opacity: 0, x: "0", y: "0" }}
                    whileInView={{ opacity: 1, x: "10px", y: "-20px" }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4, easing: "linear" }}
                  />
                  <m.span
                    className="rounded-[6px]"
                    {...{ ...fadeIn, animate: { x: "35px", y: "5px" } }}
                  ></m.span>
                </m.figure>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="bg-lightgray py-[50px] lg:py-[90px] md:py-[75px] sm:py-[50px] text-center">
          <Container>
            <m.div className="text-center justify-center row" {...fadeIn}>
              <h2 className="heading-5 font-serif w-[65%] text-[2.3rem] mb-[95px] font-semibold text-darkgray inline-block md:w-[80%] md:mb-[50px] xs:w-full">
                Advantages of Direct Admission
              </h2>
            </m.div>
            <Row className="justify-center">
              <Col lg={12} sm={8} xs={12} md={12}>
                <IconWithText
                  grid="row-cols-1 row-cols-lg-3 row-cols-md-2 row-col-sm-8 justify-center gap-y-10"
                  theme="icon-with-text-06"
                  data={IconWithTextData_06}
                  animation={fadeIn}
                />
              </Col>
            </Row>

            <div className=" mt-[20px]">
              <span className="text-red-500 font-[500]  ">Caution:</span>
              Avoid <b>Unauthorized Agents</b> or <b>Middlemen.</b> Always
              confirm that your seat is allotted through <b></b> or{" "}
              <b>MCC portal</b>.
            </div>
          </Container>
        </section>

        <Container>
          <div className=" mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {/* What are top private MBA Colleges in india? */}
              MBBS Fees Structure in Chhattisgarh
            </h2>
            <div>
              <div className=" font-[400] mt-4">Government Colleges:</div>
              <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal">
                <li>
                  <b> Tuition Fees: </b>: ₹40,000 – ₹60,000 per annum
                </li>
                <li>
                  <b>Hostel & Miscellaneous:</b> ₹15,000 – ₹25,000 annually
                </li>
              </ol>

              <div className=" font-[400] mt-4">
                Private Colleges (Regular Quota):
              </div>
              <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal">
                <li>₹6,50,000 – ₹8,00,000 per annum</li>
              </ol>

              <div className=" font-[400] mt-4">Management Quota:</div>
              <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal">
                <li>₹11,00,000 – ₹15,00,000 per annum</li>
              </ol>

              <div className=" font-[400] mt-4">NRI Quota:</div>
              <ol className="!text-[#616162] ml-10  md:ml-5 list-decimal">
                <li>₹20,00,000 – ₹25,00,000 per annum</li>
              </ol>
            </div>
          </div>

          <div className=" mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {/* What are top private MBA Colleges in india? */}
              {locationData.eighthHeading}
            </h2>
            <div>
              <p className="!text-[#616162] !opacity-100">
                {locationData.eighthPara}
              </p>

              <div className=" font-[400] mt-4">
                {locationData.sixthOlHeading}
              </div>
              {locationData.sixthOl && (
                <ol className="!text-[#616162] ml-10 md:ml-5 list-decimal">
                  {locationData.sixthOl.map((college, idx) => (
                    <li key={idx} className="mt-1">
                      <b>{college.name}</b>
                      <ol className="!text-[#616162] ml-10 md:ml-5 list-disc">
                        {college.points.map((point, i) => (
                          <li key={i} className="mt-1">
                            {point}
                          </li>
                        ))}
                      </ol>
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </div>
          <div className=" mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {/* What are top private MBA Colleges in india? */}
              {locationData.ninthHeading}
            </h2>
            <div>
              <div className=" font-[400] mt-4">{locationData.ninthPara}</div>
              {locationData.sevenOl && (
                <ol className="!text-[#616162] ml-10 md:ml-5 list-decimal">
                  {locationData.sevenOl.map((item, idx) => (
                    <li key={idx}>
                      <b>{item.title}:</b> {item.description}
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </div>

          <div className=" mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {/* What are top private MBA Colleges in india? */}
              {locationData.tenthHeading}
            </h2>
            <div>
              <p className="!text-[#616162] !opacity-100">
                {locationData.tenthPara}
              </p>

              <div className=" font-[400] mt-4">
                {locationData.eighthOlHeading}
              </div>
              {locationData.eighthOl && (
                <ol className="!text-[#616162] ml-10 md:ml-5 list-disc">
                  {locationData.eighthOl.map((item, index) => (
                    <li key={index}>
                      <b>{item}</b>
                    </li>
                  ))}
                </ol>
              )}

              <div className="mt-3 text-black">
                {locationData.eighthOlSubheading}
              </div>
            </div>
          </div>

          <div className=" mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              {/* What are top private MBA Colleges in india? */}
              {locationData.eleventhHeading}
            </h2>
            <div>
              <div className=" font-[400] mt-4">
                {locationData.ninthOlHeading}
              </div>
              {locationData.ninthOl && (
                <ol className="!text-[#616162] ml-10 md:ml-5 list-decimal">
                  {locationData.ninthOl.map((item, index) => (
                    <li key={index}>
                      <b>{item.title}</b>
                      {item.description && ` ${item.description}`}
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </div>

          <div>
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none mt-[50px]">
              Conclusion
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: locationData?.conclusion || "",
              }}
            ></div>
          </div>
        </Container>
      </section>

      <m.section
        className="cover-background py-[80px] pb-[80px] lg:py-[90px] lg:pb-[190px] md:py-[190px] md:pb-[100px] sm:py-[50px] sm:pt-[100px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/home-interior-design-about-bg.webp)",
        }}
        {...fadeIn}
      >
        <Container className="relative">
          <Row className="items-center justify-center">
            <Col
              lg={6}
              md={10}
              className="relative lg:mt-[30px] md:mb-48 sm:mb-36 md:mt-0 flex justify-center items-center"
            >
              <Parallax
                className="lg-no-parallax relative  md:w-[100%] z-[2]  lg:mt-0 lg:mr-auto "
                speed={0}
              >
                <m.img
                  // width={380}
                  // height={554}
                  src="/assets/img/Mba6176962625839043729.webp"
                  alt="image-1"
                  {...fadeIn}
                />
              </Parallax>
              {/* <Parallax
                className="lg-no-parallax flex justify-center items-center w-[65%] bg-no-repeat absolute bottom-[-100px] right-[15px] lg:!left-auto lg:!right-0"
                speed={5}
              >
                <m.img
                  width={380}
                  height={554}
                  src="assets/img/webp/MedicalCounsellingIndia/home/about/home_about.webp"
                  alt=""
                  {...fadeIn}
                />
              </Parallax> */}
            </Col>
            <m.div
              className="col-lg-5 offset-lg-1 col-md-10"
              {...{ ...fadeIn, transition: { delay: 0.4, duration: 1 } }}
            >
              <div className="font font-medium mb-[30px] flex">
                <span className="flex-shrink-0 w-[30px] h-[1px] bg-basecolor opacity-70 self-center mr-5"></span>
                <div className="flex-grow-1">
                  <span className="text-[#f78c1f] uppercase">
                    Why Choose an MBBS?
                  </span>
                </div>
              </div>
              <h2 className="heading-5 font-serif uppercase text-darkgray font-bold w-[85%] mb-[30px] xl:w-full">
                MBBS can help you achieve your career goals
              </h2>
              <p className="w-[75%] xl:w-full mb-[25px]">
                MBBS empowers you with the skills and knowledge to excel in
                today's competitive medical world. With an MBBS, you can unlock
                a world of opportunities, from clinical practice to medical
                research and beyond.
              </p>
              <Buttons
                to="/contact"
                className="btn-fill font-medium font-serif rounded-none tracking-[1px] uppercase md:mb-[15px] mt-[20px]"
                themeColor="#f78c1f"
                color="#fff"
                size="lg"
                title="CONNECT US"
              />
            </m.div>
          </Row>
        </Container>
      </m.section>
      {/* instruction section start  */}

      {/* top college details start*/}
      <section className="university_section  py-[50px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[50px] ">
        <div className="container">
          <div>
            <div className="mt-[30px] lg:mt-[30px] md:mb-16 sm:mb-36 xs:mb-10 md:mt-0">
              <h2 className=" title  text-center  text-[12px] text-[black]">
                <span>TOP MBBS COLLEGES IN</span>
                <span className="line_icon px-1">
                  <b>INDIA</b>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 500 150"
                    preserveAspectRatio="none"
                  >
                    <path d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7"></path>
                  </svg>
                </span>
              </h2>
            </div>
            <div className="mt-[50px] lg:mt-[30px]  md:mt-0">
              <div className="university_cards px-5 lg:px-5 md:!px-0 relative">
                <div className="row">
                  {topCollegeDetails.map((item, i) => {
                    return (
                      <div
                        className="col-lg-{6} col-md-6 col-sm-6 col-12"
                        key={i}
                      >
                        <div className="block-animation">
                          <div className="font-semibold flex justify-between">
                            <div className="text-[#1a1c45]">{item.name}</div>
                            <div>
                              {/* Modal Component Start */}
                              <div className="text-[#f78c1f] whitespace-pre   cursor-pointer flex items-center">
                                <Link
                                  to={item.link}
                                  className="text-[13px] pr-1"
                                >
                                  View
                                </Link>
                                <i className="fa fa-arrow-right"></i>
                              </div>
                              {/* Modal Component End */}
                            </div>
                          </div>
                          {/* <div className="">Address</div> */}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* modal section end */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* top college details end */}

      {/* Top ranking university section start */}

      {/* TOP MBBS COLLEGE */}
      {/* 
      <section
        ref={collegeSectionRef}
        className="university_section  py-[50px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[50px] "
      >
        <Container>
          <div>
            <div className="mt-[30px] lg:mt-[30px] md:mb-16 sm:mb-36 xs:mb-10 md:mt-0">
              <div className=" title  text-center  text-[12px] text-[black]">
                <span>MBA COLLEGES IN</span>
                <span className="line_icon px-1">
                  <b>INDIA</b>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 500 150"
                    preserveAspectRatio="none"
                  >
                    <path d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7"></path>
                  </svg>
                </span>
              </div>
            </div>
            <div className="mt-[50px] lg:mt-[30px]  md:mt-0">
              <div className="university_cards px-5 lg:px-5 md:!px-0 ">
                <Row className="">
                  {topUniversityData.map((item, i) => {
                    return (
                      <Col lg={3} md={6} sm={6} xs={12} key={i}>
                        <ScrollTo
                          to={`course${i}`}
                          offset={-100}
                          delay={0}
                          spy={true}
                          smooth={true}
                          duration={800}
                          className="cursor-pointer w-full"
                        >
                          <div className="block-animation cursor-pointer ">
                            <div className=" flex justify-between">
                              <div className="">{item.stateName}</div>
                            </div>
                          </div>
                        </ScrollTo>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
          </div>
        </Container>
      </section> */}

      <m.section
        className="bg-lightgray py-[130px] pb-[230px] lg:py-[90px] lg:pb-[190px] md:py-[190px] md:pb-[100px] sm:py-[50px] sm:pt-[100px]"
        // style={{
        //   backgroundImage:
        //     "url(/assets/img/webp/home-interior-design-about-bg.webp)",
        // }}
        {...fadeIn}
      >
        <Container className="relative">
          <Row className="items-center justify-between">
            <m.div
              className="col-lg-5  col-md-10"
              {...{ ...fadeIn, transition: { delay: 0.4, duration: 1 } }}
            >
              <h2 className="heading-5 font-serif uppercase text-darkgray font-bold w-[85%] mb-[30px] xl:w-full">
                Why Choose Us?
              </h2>
              <p className="w-[100%] xl:w-full mb-[25px]">
                At Counselling India, we believe in more than just guiding
                you—we're here to pave your way to success. Our team of
                experienced and dedicated college admission counselors is
                committed to offering personalized support that aligns with your
                unique dreams and aspirations. From providing expert insights to
                simplifying the application process, we're not just advisors;
                we're your partners in shaping a brighter future.
              </p>
              <p className="w-[100%] xl:w-full mb-[25px]">
                Our goal is to grant you access to top-notch admissions advice.
                When you choose Counselling India, you're choosing excellence
                for your academic journey.
              </p>
            </m.div>
            <Col
              lg={6}
              md={10}
              className="relative lg:mt-[30px] md:mb-48 sm:mb-36 md:mt-0 flex justify-center items-center"
            >
              <Parallax
                className="lg-no-parallax relative  md:w-[100%] z-[2]  lg:mt-0 lg:mr-auto "
                speed={0}
              >
                <m.img
                  // width={380}
                  // height={554}
                  src="/assets/img/mba26176962625839043733.webp"
                  alt="whyChooseUs"
                  {...fadeIn}
                />
              </Parallax>
              {/* <Parallax
                className="lg-no-parallax flex justify-center items-center w-[65%] bg-no-repeat absolute bottom-[-100px] right-[15px] lg:!left-auto lg:!right-0"
                speed={5}
              >
                <m.img
                  width={380}
                  height={554}
                  src="assets/img/webp/MedicalCounsellingIndia/home/about/home_about.webp"
                  alt=""
                  {...fadeIn}
                />
              </Parallax> */}
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Top ranking university section end */}

      {/* MBA addmision starts */}

      {/* MBA addmision Ends */}

      {/* enquiry form section start */}
      <m.section
        className="py-[160px] bg-cover 	bg-no-repeat overflow-hidden relative bg-center lg:py-[120px] md:py-[95px] xs:py-[80px] xxs:py-[50px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/MedicalCounsellingIndia/home/enquiry/enquiry.webp)",
        }}
        {...fadeIn}
      >
        <Container className="xs:px-0">
          <div className="flex justify-center mb-[100px] w-full">
            <p className="font-normal text-[20px] w-[70%] lg:w-[70%] md:w-[100%] text-center">
              Get Admission in the <b>Best MBBS Colleges in India</b>. Kindly
              submit your data below and we shall connect you as soon as
              possible.
            </p>
          </div>
          <Row className="justify-end md:justify-center">
            <Col xl={7} lg={7} md={9} sm={11}>
              <div className="px-[3rem] py-[5rem] rounded-md shadow-[0_0_30px_rgb(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-[6rem]">
                <span className="mb-[15px] font-medium text-center text-[#f78c1f] text-md font-serif uppercase block sm:mb-[10px]">
                  Submit your details here
                </span>
                <h5 className="w-[80%] mb-[40px] font-bold text-center	tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                  YOU ARE JUST A CALL AWAY
                </h5>

                <form className="mb-[30px]" onSubmit={handleSubmit(onSubmit)}>
                  <m.div
                    className="row justify-center"
                    {...{ ...fadeIn, transition: { delay: 0.6 } }}
                  >
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="name"
                          className="rounded-[5px] relative py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.name?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="email"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your email address"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                              message: "Enter valid email",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.email?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="number"
                          name="phone"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your phone number"
                          onKeyDown={handleKeyDown}
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "Phone number is required",
                            },
                            pattern: {
                              value:
                                /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                              message: "Enter valid phone number",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.phone?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="address"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your address"
                          {...register("address", {
                            required: {
                              value: true,
                              message: "Address is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.address?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="stream"
                          className="rounded-[5px] py-[13px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Stream"
                          {...register("stream", {
                            required: {
                              value: true,
                              message: "Stream is required",
                            },
                            value: "Stream",
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.stream?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <textarea
                          type="text"
                          rows={3}
                          name="message"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your message"
                          {...register("message", {
                            required: {
                              value: true,
                              message: "Message is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-10px] translate-x-[10px]">
                          {errors.message?.message}
                        </div>
                      </div>
                    </Col>
                  </m.div>

                  <Buttons
                    type="submit"
                    className={`btn-fill text-sm leading-none font-medium tracking-[1px] !py-[17px] px-[32px] rounded-[4px] w-full uppercase mb-[5px] ${
                      formLoading ? "loading" : ""
                    }`}
                    themeColor="#f78c1f"
                    color="#fff"
                    size="lg"
                    title="Request a call schedule"
                  />
                </form>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </m.section>
      {/* enquiry form section end */}
    </>
  );
}

export default MbbsAdmission;
